import CheckIcon from 'assets/icons/step-done-check.svg?component'
import Alert from 'components/UI/Alert'
import InfoBlock from 'components/UI/Blocks/InfoBlock'
import Button from 'components/UI/Buttons/Button'
import Typography from 'components/UI/Typography'
import { useAppSelector } from 'hooks'
import { useTranslation } from 'react-i18next'
import { programSelector } from 'redux/store/slices/decisionSlice'
import tw from 'twin.macro'

interface LoanTermsAgreementProps {
  isTermsAgreed: boolean
  onShowAgreement: () => void
  onAgree: () => void
}

const LoanTermsAgreement = ({ isTermsAgreed, onShowAgreement }: LoanTermsAgreementProps) => {
  // Tools
  const { t } = useTranslation()

  // Selectors
  const selectedProgram = useAppSelector(programSelector)

  if (selectedProgram === 'DAMU') {
    return !isTermsAgreed ? (
      <InfoBlock twStyle={tw`space-y-4 flex flex-col`}>
        <Typography variant='body' weight='bold'>
          {t('flow-bank-monitoring')}
        </Typography>
        <Alert>
          <Typography variant='subbody' text>
            {t('flow-accept-monitoring')}
          </Typography>
        </Alert>
        <Button variant='secondary' size='small' twStyle={tw`self-end`} onClick={onShowAgreement}>
          <Typography variant='caption' weight='bold'>
            {t('flow-view-condition')}
          </Typography>
        </Button>
      </InfoBlock>
    ) : (
      <InfoBlock twStyle={tw`flex items-center`}>
        <div>
          <Typography weight='bold'>{t('flow-agree-with-monitoring')}</Typography>
          <Button variant='link' onClick={onShowAgreement}>
            {t('flow-view-conditions-again')}
          </Button>
        </div>
        <CheckIcon tw='flex-shrink-0 w-5 h-5' />
      </InfoBlock>
    )
  }

  // return (
  //   <InfoBlock twStyle={tw`space-y-4 flex flex-col`}>
  //     <Typography variant='body' weight='bold'>
  //       {t('flow-bank-monitoring-own')}
  //     </Typography>
  //     <Alert>
  //       <Typography variant='subbody' text>
  //         <Trans
  //           i18nKey='flow-accept-monitoring-own'
  //           components={{
  //             whatsapp: (
  //               <Link
  //                 tw='text-primary font-semibold underline'
  //                 href='https://api.whatsapp.com/send?phone=77761595595'
  //                 target='_blank'
  //                 rel='noreferrer'
  //               />
  //             )
  //           }}
  //         />
  //       </Typography>
  //     </Alert>
  //     <Button variant='secondary' size='small' twStyle={tw`self-end`} disabled={isTermsAgreed} onClick={onAgree}>
  //       <Typography variant='caption' weight='bold'>
  //         {t('flow-view-condition')}
  //       </Typography>
  //     </Button>
  //   </InfoBlock>
  // )
}

export default LoanTermsAgreement
